let PackagesItem = [
    {
        id: 1,
        trackTitle: "Full Access",
        trackSubtitle: "For Middle and Senior specialists",
        trackPrice: "$299",
        trackDesc: "1",
        trackButton: "Register",
        trackFull: 'Full Access to all talks & Q&A sessions recordings',
        trackLink: 'https://geekle.us/ticket/1635170121001x525858368651001860',
    },
    {
        id: 2,
        trackTitle: "Entry-level day",
        trackSubtitle: "For Junior specialists",
        trackPrice: "Free",
        trackButton: "Register",
        trackQA: 'Live Q&A panels from a Entry-level day',
        trackLink: 'https://geekle.us/ticketfree/1635170115749x387825691517255700',
    },
  ];
  
  export default PackagesItem;
  